import React from "react";
import Avatar from "components/Avatar";
import homelogo from "assets/icons/home.png";
import { MdClearAll } from "react-icons/md";
import { Button, Nav, Navbar, NavItem, NavLink } from "reactstrap";
import bn from "utils/bemnames";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "slices/appSlice";
import { useLocation, useNavigate } from "react-router-dom";

const bem = bn.create("header");

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { isSidebarOpen } = useSelector((state) => state.app);

  const handleSidebarControlButton = (event) => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector(".cr-sidebar").classList.toggle("cr-sidebar--open");
    dispatch(toggleSidebar(!isSidebarOpen));
  };

  return (
    <Navbar light expand className={bem.b("bg-white")}>
      <Nav navbar className="mr-2 gap-3">
        <Button
          outline
          onClick={handleSidebarControlButton}
          className="sidebar-btn"
          title={isSidebarOpen ? "Collapse Sidebar" : "Open Sidebar"}
        >
          <MdClearAll size={25} />
        </Button>
        {location.pathname !== "/" && (
          <Button
            outline
            className="home-btn"
            onClick={() => navigate("/")}
            title="Go to Home Page"
          >
            <img src={homelogo} width="30" height="30" alt="home" />
          </Button>
        )}
      </Nav>
      <Nav navbar className={bem.e("nav-right")}>
        <NavItem>
          <NavLink id="Popover2">
            <Avatar />
          </NavLink>
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Header;
